module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }